import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    position: 'relative',
  },
  buttonProgress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

// this component was built using https://material-ui.com/components/progress as a reference
export default function LoadingButton(props) {
  const { children, type, isSubmitting, fullWidth, variant, color } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <Button
          type={type}
          disabled={isSubmitting}
          variant={variant}
          color={color}
          fullWidth={fullWidth}
        >
          {children}
        </Button>
        {isSubmitting ? <CircularProgress size={24} className={classes.buttonProgress} /> : null}
      </div>
    </div>
  );
}

// children, type, isSubmitting, fullWidth, variant, color
LoadingButton.defaultProps = {
  children: '',
  type: '',
  isSubmitting: false,
  fullWidth: false,
  variant: '',
  color: '',
};

LoadingButton.propTypes = {
  children: PropTypes.node,
  type: PropTypes.string,
  isSubmitting: PropTypes.bool,
  fullWidth: PropTypes.bool,
  variant: PropTypes.string,
  color: PropTypes.string,
};
